<template>
  <div class="card-tag">
    <div class="icon" :style="{ color: color }">#</div>
    <div class="content">{{ content }}</div>
  </div>
</template>

<script>
export default {
  name: 'CardTag',
  props: {
    theme: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    color () {
      let value = ''
      switch (this.theme) {
        case 'blue':
          value = '#3B7CFF'
          break
        case 'orange':
          value = '#FA561F'
          break
        default:
          value = '#f4282d'
          break
      }
      return value
    }
  }
}
</script>

<style lang="sass" scoped>
.card-tag
  display: inline-block
  vertical-align: bottom
  box-sizing: border-box
  margin: 0
  padding: 0
  height: 18px
  list-style: none
  cursor: pointer
  white-space: nowrap

  .icon
    display: inline
    margin-right: 2px
    padding: 0
    color: #f4282d
    font-size: 10px
    line-height: 14px
    text-align: left

  .content
    display: inline
    color: #999
    font-size: 12px
    line-height: 18px
    text-align: left

</style>
